module.exports = __webpack_public_path__ + "img/shape-2-mobile-gold@2x.b28bdcce.png";